import { createElementBlock as t, openBlock as l, createElementVNode as n } from "vue";
const o = {
  width: "34",
  height: "34",
  viewBox: "0 0 34 34",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  class: "svg__icon-ftva-email"
};
function i(s, e) {
  return l(), t("svg", o, e[0] || (e[0] = [
    n("path", {
      d: "M27 11.375C27 10.3438 26.1 9.5 25 9.5H9C7.9 9.5 7 10.3438 7 11.375V22.625C7 23.6562 7.9 24.5 9 24.5H25C26.1 24.5 27 23.6562 27 22.625V11.375ZM25 11.375L17 16.0625L9 11.375H25ZM25 22.625H9V13.25L17 17.9375L25 13.25V22.625Z",
      fill: "#115DAF",
      class: "svg__fill--accent-blue"
    }, null, -1)
  ]));
}
const r = { render: i };
export {
  r as default,
  i as render
};
